import {
  type IProductModel,
  type ITextComponentWithAssetsModel,
} from "@nf/common";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

import AppImage from "components/AppImage";
import LandingPageBrand from "components/LandingPage/LandingPageBrand";

import { LANDING_PAGE_COMPONENT_SUB_TYPE } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";
import type { ILandingPageJoinUsComponent } from "../types";

import styles from "./LandingPageJoinUs.module.scss";

const LandingPageOffers = dynamic(
  () => import("components/LandingPage/LandingPageOffers")
);

interface LandingPageJoinUsProps {
  component: ITextComponentWithAssetsModel;
  offers?: IProductModel[];
}

const LandingPageJoinUs = ({ component, offers }: LandingPageJoinUsProps) => {
  const { t } = useTranslation("translations");
  const { sub_type, left_image_url, right_image_url } =
    component.TextParsed as unknown as ILandingPageJoinUsComponent;

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        {left_image_url && (
          <AppImage
            alt=""
            src={left_image_url}
            fill={false}
            className={styles.left}
          />
        )}
        {right_image_url && (
          <AppImage
            alt=""
            src={right_image_url}
            fill={false}
            className={styles.right}
          />
        )}
      </div>

      <div className={styles.content}>
        <LandingPageBrand>
          <span className={styles.title}>
            {t("web_landing_page_about_bottom_text")}
          </span>
        </LandingPageBrand>

        {sub_type === LANDING_PAGE_COMPONENT_SUB_TYPE.OFFERS && offers && (
          <LandingPageOffers offers={offers} />
        )}
      </div>
    </div>
  );
};

export default LandingPageJoinUs;
